module.exports = __webpack_public_path__ + "static/media/logo-sm-light.64a02162.png";